import Model from '../models'
import API from '../../api'

Model.Item.actions.fetchAllOnPage = function (cartId) {
  let id

  let products = document.getElementsByClassName('booqable-product')

  const itemIds = []
  const specificIds = []

  for (const node of Array.from(products)) {
    ({ id } = node.dataset)
    itemIds.push(id)
  }

  products = document.getElementsByClassName('booqable-product-button')

  for (const node of Array.from(products)) {
    ({ id } = node.dataset)
    specificIds.push(id)
  }

  products = document.getElementsByClassName('booqable-product-detail')

  for (const node of Array.from(products)) {
    ({ id } = node.dataset)
    specificIds.push(id)
  }

  if (specificIds.length > 0) {
    Model.Bundle.actions.fetchAll({ ids: specificIds, cart_id: cartId, apiVersion: 3 })
    Model.ProductGroup.actions.fetchAll({ ids: specificIds, cart_id: cartId, apiVersion: 3, include: 'products' })
  }

  if (itemIds.length > 0) {
    Model.Item.actions.fetchAll({ ids: itemIds, cart_id: cartId, apiVersion: 3 })
  }
}

Model.Item.createAction('FETCH_ALL', (options) => {
  if (options == null) {
    options = {}
  }

  return API.post('items', options)
})

export default Model.Item.actions
